import mainView from '@/app/index'

import publicRoutes from '@/app/public/router'
import privateRoutes from '@/app/private/router'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'Public/Default' },
    component: mainView,
    children: [
      publicRoutes,
      privateRoutes
    ]
  }
]

export default routes
